import { useEffect, useRef } from "react";

import { SuggestionProps } from "./suggestion";
import createSuggestion from "./suggestion";

// You can extend this to also support hashtag suggestions similarly
export function useMentionSuggestions(
  trigger: string,
  suggestions: SuggestionProps[],
  userId?: string,
) {
  const suggestionRef = useRef<SuggestionProps[]>(suggestions);

  useEffect(() => {
    suggestionRef.current = suggestions;
  }, [suggestions]);

  // Recents are stored per user; the popup renders in its own React root (outside
  // the Redux provider), so the id has to be threaded in rather than selected.
  return createSuggestion(trigger, suggestionRef, userId);
}
